import { render } from "./DonorsPage.vue?vue&type=template&id=3bb0f923"
import script from "./DonorsPage.vue?vue&type=script&lang=js"
export * from "./DonorsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__